module.exports = __webpack_public_path__ + "img/bag-plus.2e43a285.svg";